import { useState } from 'react';
import { Navbar } from './components';
import './App.css';
import Menu from './Pages/Menu/Menu';
import Home from './Pages/Home/Home';
import Order from './Pages/Order/Order';
import FindUs from './Pages/FindUs/FindUs';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import PageTransition from './components/PageTransition';

function AnimatedRoutes() {
  const location = useLocation();
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/menu"
          element={
            <PageTransition>
              <Navbar toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
              <Menu isOverlayOpen={toggleMenu} />
            </PageTransition>
          }
        />

        <Route
          path="/home"
          element={
            <PageTransition>
              <Navbar toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
              <Home />
            </PageTransition>
          }
        />

        <Route
          path="/findUs"
          element={
            <PageTransition>
              <Navbar toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
              <FindUs />
            </PageTransition>
          }
        />

        <Route
          path="/order"
          element={
            <PageTransition>
              <Navbar toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
              <Order />
            </PageTransition>
          }
        />

        <Route
          path="/"
          element={
            <PageTransition>
              <Navbar toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
              <Home />
            </PageTransition>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

const App = () => (
  <div>
    <Router>
      <AnimatedRoutes />
    </Router>
  </div>
);

export default App;